import { t } from "i18next";
import { z } from "zod";

import { emailRule, nameRule, phoneRule } from "src/core/forms/validators/rules";

export const editContactSchema = () =>
  z.object({
    prenom: nameRule(t, { checkIfShown: true }),
    nom: nameRule(t, { checkIfShown: true }),
    email: emailRule(t, true),
    telephone: phoneRule(t, true),
    expertComptable: z.string(),
    isFollowing: z.boolean().optional(),
    folowers: z.array(z.string()).optional(),
  });

export type EditContactFieldsValues = z.infer<ReturnType<typeof editContactSchema>>;

export const defaultEditContactValues: EditContactFieldsValues = {
  prenom: "",
  nom: "",
  email: "",
  telephone: "",
  expertComptable: "",
  isFollowing: false,
  folowers: [],
};
